/**
 * Contains the list of the document content types.
 */

const DOCUMENT_TYPE_LIST = ['MOST_USED', 'MOST_SHARED', 'MOST_TRENDING'];

export { DOCUMENT_TYPE_LIST };
